import type { SVGProps } from "react";

export default function VisualAestheticIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.7294 12.7462C2.02113 11.826 1.66699 11.3659 1.66699 9.99978C1.66699 8.63361 2.02113 8.17356 2.7294 7.25339C4.14363 5.41608 6.51542 3.33311 10.0003 3.33311C13.4852 3.33311 15.857 5.41608 17.2712 7.25339C17.9795 8.17356 18.3337 8.63361 18.3337 9.99978C18.3337 11.3659 17.9795 11.826 17.2712 12.7462C15.857 14.5834 13.4852 16.6664 10.0003 16.6664C6.51542 16.6664 4.14363 14.5834 2.7294 12.7462Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
      <path
        d="M12.5 9.99992C12.5 11.3807 11.3807 12.4999 10 12.4999C8.61925 12.4999 7.5 11.3807 7.5 9.99992C7.5 8.61917 8.61925 7.49992 10 7.49992C11.3807 7.49992 12.5 8.61917 12.5 9.99992Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
